/* Color theme toggle (default dark; persisted in localStorage) */
(function () {
    var STORAGE_KEY = '1473-color-scheme';

    function readLabels() {
        var btn = document.querySelector('[data-theme-toggle]');
        if (!btn) {
            return { whenDark: 'Switch to light mode', whenLight: 'Switch to dark mode' };
        }
        return {
            whenDark: btn.getAttribute('data-label-when-dark') || 'Switch to light mode',
            whenLight: btn.getAttribute('data-label-when-light') || 'Switch to dark mode',
        };
    }

    function applyTheme(theme) {
        var root = document.documentElement;
        root.classList.remove('theme-light', 'theme-dark');
        root.classList.add('theme-' + theme);
        root.setAttribute('data-theme', theme);
        try {
            localStorage.setItem(STORAGE_KEY, theme);
        } catch (e) {}

        var labels = readLabels();
        document.querySelectorAll('[data-theme-toggle]').forEach(function (el) {
            el.setAttribute('aria-label', theme === 'dark' ? labels.whenDark : labels.whenLight);
        });
    }

    document.querySelectorAll('[data-theme-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
            var cur = document.documentElement.getAttribute('data-theme') || 'dark';
            applyTheme(cur === 'dark' ? 'light' : 'dark');
        });
    });

    applyTheme(document.documentElement.getAttribute('data-theme') || 'dark');
})();

/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    if (!navigation) return;
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    function closeMenu() {
        navigation.classList.remove('is-open');
        document.documentElement.style.overflowY = null;
        document.body.style.overflow = null;
        document.body.style.position = null;
        document.body.style.width = null;
    }

    function openMenu() {
        navigation.classList.add('is-open');
        document.documentElement.style.overflowY = 'hidden';
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        const inner = navigation.querySelector('.gh-navigation-inner');
        if (inner) inner.scrollTop = 0;
    }

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            openMenu();
        } else {
            closeMenu();
        }
    });

    window.addEventListener('resize', function () {
        if (window.matchMedia('(min-width: 768px)').matches) {
            closeMenu();
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();

/* Trending tags carousel (footer) */
(function () {
    const root = document.querySelector('.gh-trending-tags');
    if (!root) return;
    const track = root.querySelector('.gh-trending-tags-track');
    const prev = root.querySelector('.gh-trending-tags-prev');
    const next = root.querySelector('.gh-trending-tags-next');
    if (!track || !prev || !next) return;

    function step() {
        const card = track.querySelector('.gh-trending-tags-card');
        const w = card ? card.offsetWidth : 280;
        return Math.min(w + 20, track.clientWidth * 0.9);
    }

    prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
    });
})();

/* Homepage bottom feed: load more via Content API (Landing header only; see partials/components/post-list.hbs) */
(function () {
    const root = document.querySelector('[data-home-feed]');
    if (!root) return;

    const siteUrlRaw = root.getAttribute('data-site-url') || '';
    const siteUrl = siteUrlRaw.replace(/\/$/, '');
    const feed = root.querySelector('.gh-feed--cards') || root.querySelector('.gh-feed');
    const btn = root.querySelector('.gh-home-feed-loadmore');
    const winKey =
        typeof window !== 'undefined' && window.ghostContentApiKey
            ? String(window.ghostContentApiKey).trim()
            : '';
    const key = winKey;

    if (!feed || !siteUrl) return;

    if (!key || !btn) {
        if (btn) {
            const footer = btn.closest('.gh-home-feed-footer');
            if (footer) footer.remove();
        }
        return;
    }

    const byLabel = (root.getAttribute('data-meta-by') || 'By').trim();
    const showAuthor = root.getAttribute('data-show-author') === '1';
    let page = 2;
    let loading = false;

    function excerptToPlain(html) {
        if (!html) return '';
        const d = document.createElement('div');
        d.innerHTML = html;
        return (d.textContent || '').replace(/\s+/g, ' ').trim();
    }

    function buildCard(post) {
        const article = document.createElement('article');
        article.className = 'gh-card';

        const link = document.createElement('a');
        link.className = 'gh-card-link';
        link.href = post.url || '#';

        if (post.feature_image) {
            const fig = document.createElement('figure');
            fig.className = 'gh-card-image';
            const img = document.createElement('img');
            img.src = post.feature_image;
            img.alt = post.feature_image_alt || post.title || '';
            img.loading = 'lazy';
            fig.appendChild(img);
            link.appendChild(fig);
        }

        const wrap = document.createElement('div');
        wrap.className = 'gh-card-wrapper';

        const h3 = document.createElement('h3');
        h3.className = 'gh-card-title is-title';
        h3.textContent = post.title || '';
        wrap.appendChild(h3);

        const excerptPlain = excerptToPlain(post.custom_excerpt || post.excerpt || '');
        if (excerptPlain) {
            const p = document.createElement('p');
            p.className = 'gh-card-excerpt is-body';
            p.textContent = excerptPlain;
            wrap.appendChild(p);
        }

        const authors = (post.authors || [])
            .map(function (a) {
                return a.name;
            })
            .filter(Boolean)
            .join(', ');

        if (showAuthor && authors) {
            const foot = document.createElement('footer');
            foot.className = 'gh-card-meta';

            const auth = document.createElement('span');
            auth.className = 'gh-card-author';
            auth.textContent = byLabel + ' ' + authors;
            foot.appendChild(auth);

            wrap.appendChild(foot);
        }

        link.appendChild(wrap);
        article.appendChild(link);
        return article;
    }

    btn.addEventListener('click', function () {
        if (loading) return;
        loading = true;
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');

        const base = siteUrl.endsWith('/') ? siteUrl : siteUrl + '/';
        const url = new URL('ghost/api/content/posts/', base);
        url.searchParams.set('key', key);
        url.searchParams.set('limit', '12');
        url.searchParams.set('page', String(page));
        url.searchParams.set('order', 'published_at desc');
        url.searchParams.set('filter', 'tag:-hash-video');
        url.searchParams.set('include', 'authors');

        fetch(url.toString())
            .then(function (res) {
                if (!res.ok) throw new Error('bad response');
                return res.json();
            })
            .then(function (data) {
                const posts = data.posts || [];
                const pag = data.meta && data.meta.pagination;

                posts.forEach(function (post) {
                    feed.appendChild(buildCard(post));
                });

                if (!pag || !pag.next || posts.length === 0) {
                    btn.remove();
                    const footer = root.querySelector('.gh-home-feed-footer');
                    if (footer && !footer.querySelector('.gh-home-feed-loadmore')) {
                        footer.remove();
                    }
                } else {
                    page = pag.next;
                    btn.disabled = false;
                }
            })
            .catch(function () {
                btn.disabled = false;
            })
            .finally(function () {
                loading = false;
                if (btn.isConnected) btn.removeAttribute('aria-busy');
            });
    });
})();

/* Video posts carousel (hash-video) */
(function () {
    const root = document.querySelector('.gh-video-posts');
    if (!root) return;
    const track = root.querySelector('.gh-video-posts-track');
    const prev = root.querySelector('.gh-video-posts-prev');
    const next = root.querySelector('.gh-video-posts-next');
    if (!track || !prev || !next) return;

    function step() {
        const card = track.querySelector('.gh-video-posts-card');
        const w = card ? card.offsetWidth : 360;
        return Math.min(w + 24, track.clientWidth * 0.9);
    }

    prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
    });
})();

/* Homepage hero feed rail uses native smooth scrolling */

/* Ghost member comments CTA copy (comments-ui strings are not theme-locale driven) */
(function () {
    var HEADING_WAS = 'Start the conversation';
    var HEADING_NOW = 'Have your say';
    var SUB_FREE_RE = /^Become a member of .+ to start commenting\.?$/;
    var SUB_NOW = 'Join 1473 for free to have your say';

    var rafId = 0;

    function patchGhostCommentsCta() {
        document.querySelectorAll('.gh-comments').forEach(function (root) {
            var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
            var node;
            while ((node = walker.nextNode())) {
                var raw = node.textContent;
                if (!raw) continue;
                if (raw === HEADING_WAS || raw.trim() === HEADING_WAS) {
                    node.textContent = HEADING_NOW;
                    continue;
                }
                var t = raw.trim();
                if (SUB_FREE_RE.test(t)) {
                    node.textContent = raw.replace(t, SUB_NOW);
                }
            }
        });
    }

    function schedulePatch() {
        if (rafId) return;
        rafId = requestAnimationFrame(function () {
            rafId = 0;
            patchGhostCommentsCta();
        });
    }

    function watch(el) {
        var obs = new MutationObserver(schedulePatch);
        obs.observe(el, {subtree: true, childList: true, characterData: true});
    }

    document.querySelectorAll('.gh-comments').forEach(watch);
    schedulePatch();
})();